import { defaultReturn, generateDefaultActions, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";
import { put, call, takeLatest } from "redux-saga/effects";
import { authorizedRequest } from "utils/api";
import { ToastError } from "components/Global/Toasts/Toasty";

import { DSCR_TYPE_NAMES } from "./helpers";

export const SET_DSCR_LINE_ITEM_SELECTIONS = generateDefaultActions("SET_DSCR_LINE_ITEM_SELECTIONS");
export const setDscrLineItemSelections = payload => makeWritePayload(SET_DSCR_LINE_ITEM_SELECTIONS.value, payload);

export const SET_DRAFT_AS_OF_DATE = generateDefaultActions("SET_DRAFT_AS_OF_DATE");
export const setDraftAsOfDate = payload => makeWritePayload(SET_DRAFT_AS_OF_DATE.value, payload);

export const SET_DSCR_LINE_ITEMS_TO_DEFAULT = generateDefaultActions("SET_DSCR_LINE_ITEMS_TO_DEFAULT");
export const setDscrLineItemsToDefault = payload => makeWritePayload(SET_DSCR_LINE_ITEMS_TO_DEFAULT.value, payload);

export const GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI = generateDefaultActions("GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI");
export const getMostRecentAsOfDateAmongRGI = payload => makeWritePayload(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.value, payload);
function* getMostRecentAsOfDateAmongRGISaga({ payload }) {
  const url = `/report-groups/instances/${payload.reportGroupId}/recentAsOfDate`;
  yield requestSaga(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI, url, "GET", null, null, null, true);
}

export const GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI = generateDefaultActions("GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI");
export const getMostRecentProjectedAsOfDateAmongRGI = payload => makeWritePayload(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.value, payload);
function* getMostRecentProjectedAsOfDateAmongRGISaga({ payload }) {
  const url = `/report-groups/instances/projected/${payload.reportGroupId}/recentAsOfDate`;
  yield requestSaga(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI, url, "GET", null, null, null, true);
}

export const CALCULATE_MOST_RECENT_PAYMENT = generateDefaultActions("CALCULATE_MOST_RECENT_PAYMENT");
export const calculateMostRecentPayment = payload => makeWritePayload(CALCULATE_MOST_RECENT_PAYMENT.value, payload);
function* calculateMostRecentPaymentSaga({ payload }) {
  const { loanId, group, asOfDate } = payload;
  const url = `/calculations/getLoanMostRecentPayment/${loanId}/${asOfDate}`;
  const response = yield call(authorizedRequest, url, "GET",null, null, true);
  yield put({ type: CALCULATE_MOST_RECENT_PAYMENT.success, payload: { group, calculatedValue: response.data?.total ? response.data.total * 12 : null } });
}

export const CALCULATE_RATE_REPLACEMENT = generateDefaultActions("CALCULATE_RATE_REPLACEMENT");
export const calculateRateReplacement = payload => makeWritePayload(CALCULATE_RATE_REPLACEMENT.value, payload);
function* calculateRateReplacementSaga({ payload }) {
  const { loanId, group, asOfDate, periodsCovered, periods, replacementRate } = payload;
  const queryString = `asOfDate=${asOfDate}&periodsCovered=${periodsCovered}&periods=${periods}&replacementRate=${replacementRate}`;
  const url = `/calculations/rateReplacement/${loanId}/${asOfDate}?${queryString}`;
  const response = yield call(authorizedRequest, url, "GET", null, null, true);
  yield put({ type: CALCULATE_RATE_REPLACEMENT.success, payload: { group, calculatedValue: response?.data?.total } });
}

export const CALCULATE_PROJECTED_CASHFLOWS = generateDefaultActions("CALCULATE_PROJECTED_CASHFLOWS");
export const calculateProjectedCashflows = payload => makeWritePayload(CALCULATE_PROJECTED_CASHFLOWS.value, payload);
function* calculateProjectedCashflowsSaga({ payload }) {
  const { loanId, periods, asOfDate, group } = payload;
  const queryString = `asOfDate=${asOfDate}&periods=${periods}`;
  const url = `/calculations/projectedCashflows/${loanId}/${asOfDate}?${queryString}`;
  const response = yield call(authorizedRequest, url, "GET", null, null, true);
  yield put({ type: CALCULATE_PROJECTED_CASHFLOWS.success, payload: { group, calculatedValue: response?.data?.total } });
}

export const CALCULATE_TRAILING_CASHFLOWS = generateDefaultActions("CALCULATE_TRAILING_CASHFLOWS");
export const calculateTrailingCashflows = payload => makeWritePayload(CALCULATE_TRAILING_CASHFLOWS.value, payload);
function* calculateTrailingCashflowsSaga({ payload }) {
  const { loanId, periods, asOfDate, group } = payload;
  const queryString = `asOfDate=${asOfDate}&periods=${periods}`;
  const url = `/calculations/trailingCashflows/${loanId}/${asOfDate}?${queryString}`;
  const response = yield call(authorizedRequest, url, "GET", null, null, true);
  yield put({ type: CALCULATE_TRAILING_CASHFLOWS.success, payload: { group, calculatedValue: response?.data?.total } });
}

export const CALCULATE_HYPOTHETICAL_AMORTIZATION = generateDefaultActions("CALCULATE_HYPOTHETICAL_AMORTIZATION");
export const calculateHypotheticalAmortization = payload => makeWritePayload(CALCULATE_HYPOTHETICAL_AMORTIZATION.value, payload);
function* calculateHypotheticalAmortizationSaga({ payload }) {
  const { loanId, group, asOfDate, periods, fixedRate, treasurySpread, floatingRateSpread, dscrSwapRate, floatingRateMethod, overrideRate, loanBalanceType } = payload;
  const queryString =
    `asOfDate=${asOfDate}&periods=${periods}&fixedRate=${fixedRate}&treasurySpread=${treasurySpread}` +
    `&floatingRateSpread=${floatingRateSpread}&dscrSwapRate=${dscrSwapRate}` +
    `&floatingRateMethod=${floatingRateMethod}&overrideRate=${overrideRate}` +
    `&loanBalanceType=${loanBalanceType}`;
  const url = `/calculations/hypotheticalAmortization/${loanId}/${asOfDate}?${queryString}`;
  try {
    const response = yield call(authorizedRequest, url, "GET", null, null, true);
    yield put({ type: CALCULATE_HYPOTHETICAL_AMORTIZATION.success, payload: { group, calculatedValue: response?.data } });
  } catch (_error) {
    yield put({ type: CALCULATE_HYPOTHETICAL_AMORTIZATION.failure, payload: { group, calculatedValue: null } });
  }
}

export const CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL = generateDefaultActions("CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL");
export const calculateMaxInterestPlusActualPrincipal = payload => makeWritePayload(CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.value, payload);
function* calculateMaxInterestPlusActualPrincipalSaga({ payload }) {
  const { loanId, asOfDate, floatingRateSpread, group, floatingRateMethod } = payload;
  const queryString =
    `floatingRateSpread=${floatingRateSpread}&floatingRateMethod=${floatingRateMethod}`;
  const url = `/calculations/calculateMaxInterestPlusActualPrincipal/${loanId}/${asOfDate}?${queryString}`;
  const response = yield call(authorizedRequest, url, "GET", null, null, true);
  yield put({ type: CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.success, payload: { group, calculatedValue: response?.data?.total } });
}

export const actionCreators = {
  setDscrLineItemSelections,
  getMostRecentAsOfDateAmongRGI,
  calculateMostRecentPayment,
  calculateRateReplacement,
  calculateProjectedCashflows,
  calculateTrailingCashflows,
  calculateHypotheticalAmortization,
  calculateMaxInterestPlusActualPrincipal,
  setDscrLineItemsToDefault,
  getMostRecentProjectedAsOfDateAmongRGI,
  setDraftAsOfDate
};

const initialState = {
  isEditing: false,
  lineItemType: "value",
  resultValue: null,
  selectedDscrType: null,
  selectedComparisonType1: null,
  selectedComparisonType2: null,
  calculatedComparisonValue1: null,
  calculatedComparisonValue2: null,
  calculationFieldsInputValues: null,
  comparisonCalculationFieldsInputValues1: null,
  comparisonCalculationFieldsInputValues2: null,
  isCalculating: false,
  recentAsOfDate: null,
  onDoneCalculate: false,
  selectedFromFileField: null,
  draftAsOfDate: null
};

const determineStatePropToUpdate = comparisonGroup => {
  if (comparisonGroup === "first") {
    return "calculatedComparisonValue1";
  } else if (comparisonGroup === "second") {
    return "calculatedComparisonValue2";
  }

  return "resultValue";
};

export const lenderReportDscrLineItemManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DSCR_LINE_ITEM_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DRAFT_AS_OF_DATE.value:
      return defaultReturn({ ...state }, payload, "draftAsOfDate");

    case SET_DSCR_LINE_ITEMS_TO_DEFAULT.value:
      return defaultReturn({ ...initialState });

    case GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.failure:
      ToastError("Failed to get most recent as of date for report group.  The calculation cannot be completed.");

      return defaultReturn({ ...state }, null, "recentAsOfDate");
    case GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.success:
      return defaultReturn({ ...state }, payload.data, "recentAsOfDate");

      case GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.failure:
        ToastError("Failed to get most recent projected as of date for report group.  The calculation cannot be completed.");

        return defaultReturn({ ...state }, null, "recentAsOfDate");
      case GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.success:
        return defaultReturn({ ...state }, payload.data, "recentAsOfDate");

    case CALCULATE_MOST_RECENT_PAYMENT.failure:
      ToastError(`${DSCR_TYPE_NAMES.MOST_RECENT_PAYMENT} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_MOST_RECENT_PAYMENT.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_MOST_RECENT_PAYMENT.value:
      return defaultReturn({ ...state, isCalculating: true });

    case CALCULATE_RATE_REPLACEMENT.failure:
      ToastError(`${DSCR_TYPE_NAMES.RATE_REPLACEMENT} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_RATE_REPLACEMENT.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_RATE_REPLACEMENT.value:
      return defaultReturn({ ...state, isCalculating: true });

    case CALCULATE_PROJECTED_CASHFLOWS.failure:
      ToastError(`${DSCR_TYPE_NAMES.ACTUAL_PROJECTED_CASHFLOWS} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_PROJECTED_CASHFLOWS.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_PROJECTED_CASHFLOWS.value:
      return defaultReturn({ ...state, isCalculating: true });

    case CALCULATE_TRAILING_CASHFLOWS.failure:
      ToastError(`${DSCR_TYPE_NAMES.ACTUAL_TRAILING_CASHFLOWS} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_TRAILING_CASHFLOWS.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_TRAILING_CASHFLOWS.value:
      return defaultReturn({ ...state, isCalculating: true });

    case CALCULATE_HYPOTHETICAL_AMORTIZATION.failure:
      ToastError(`${DSCR_TYPE_NAMES.HYPOTHETICAL_AMORTIZATION} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_HYPOTHETICAL_AMORTIZATION.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_HYPOTHETICAL_AMORTIZATION.value:
      return defaultReturn({ ...state, isCalculating: true });

    case CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.failure:
      ToastError(`${DSCR_TYPE_NAMES.MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL} calculation failed`);

      return defaultReturn({ ...state, isCalculating: false });
    case CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.success: {
      const { group, calculatedValue } = payload;
      const propToUpdate = determineStatePropToUpdate(group);

      return defaultReturn({ ...state, isCalculating: false }, calculatedValue, propToUpdate);
    }
    case CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.value:
      return defaultReturn({ ...state, isCalculating: true });

    default:
      return state;
  }
};

export function* lenderReportDscrLineItemsSaga() {
  yield takeLatest(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.value, getMostRecentAsOfDateAmongRGISaga);
  yield takeLatest(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.value, getMostRecentProjectedAsOfDateAmongRGISaga);
  yield takeLatest(CALCULATE_MOST_RECENT_PAYMENT.value, calculateMostRecentPaymentSaga);
  yield takeLatest(CALCULATE_RATE_REPLACEMENT.value, calculateRateReplacementSaga);
  yield takeLatest(CALCULATE_TRAILING_CASHFLOWS.value, calculateTrailingCashflowsSaga);
  yield takeLatest(CALCULATE_PROJECTED_CASHFLOWS.value, calculateProjectedCashflowsSaga);
  yield takeLatest(CALCULATE_HYPOTHETICAL_AMORTIZATION.value, calculateHypotheticalAmortizationSaga);
  yield takeLatest(CALCULATE_MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL.value, calculateMaxInterestPlusActualPrincipalSaga);
}